import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
    import { Modal, Typo } from '@travelata-libs/ui-kit';
    import { ConfirmationType } from '../lib/types';
    import ConfirmationTypeIcon from './ConfirmationTypeIcon.vue';
    import getConfirmationTypeName from '../lib/getConfirmationTypeName';
    import ConfirmationTypeAdditionals from './ConfirmationTypeAdditionals.vue';

    interface ConfirmationTypeModalProps {
        type: ConfirmationType;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationTypeModal',
  props: {
    type: null
  },
  setup(__props: any) {

const props = __props as {
        type: ConfirmationType;
    }

    

    const isVisible = ref(false);

    const confirmationName = computed(() => getConfirmationTypeName(props.type));


return { __sfc: true,props, isVisible, confirmationName, Modal, Typo, ConfirmationTypeIcon, ConfirmationTypeAdditionals }
}

})